import React from 'react';
// styles
import styled from 'styled-components';

const LockIcon = ({ className, ...props }) => (
  <svg
    {...props}
    aria-label="Lock"
    className={className}
    role="img"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.625 7.125H14.0625V5.0625C14.0625 3.71984 13.5291 2.43217 12.5797 1.48277C11.6303 0.533369 10.3427 0 9 0C7.65734 0 6.36967 0.533369 5.42027 1.48277C4.47087 2.43217 3.9375 3.71984 3.9375 5.0625V7.125H3.375C2.97718 7.125 2.59564 7.28304 2.31434 7.56434C2.03304 7.84564 1.875 8.22718 1.875 8.625V16.5C1.875 16.8978 2.03304 17.2794 2.31434 17.5607C2.59564 17.842 2.97718 18 3.375 18H14.625C15.0228 18 15.4044 17.842 15.6857 17.5607C15.967 17.2794 16.125 16.8978 16.125 16.5V8.625C16.125 8.22718 15.967 7.84564 15.6857 7.56434C15.4044 7.28304 15.0228 7.125 14.625 7.125ZM9 13.875C8.70333 13.875 8.41332 13.787 8.16664 13.6222C7.91997 13.4574 7.72771 13.2231 7.61418 12.949C7.50065 12.6749 7.47094 12.3733 7.52882 12.0824C7.5867 11.7914 7.72956 11.5241 7.93934 11.3143C8.14912 11.1046 8.41639 10.9617 8.70736 10.9038C8.99834 10.8459 9.29994 10.8756 9.57402 10.9892C9.84811 11.1027 10.0824 11.295 10.2472 11.5416C10.412 11.7883 10.5 12.0783 10.5 12.375C10.5 12.7728 10.342 13.1544 10.0607 13.4357C9.77935 13.717 9.39782 13.875 9 13.875ZM12.1875 6.75C12.1875 6.84946 12.148 6.94484 12.0777 7.01517C12.0073 7.08549 11.912 7.125 11.8125 7.125H6.1875C6.08804 7.125 5.99266 7.08549 5.92233 7.01517C5.85201 6.94484 5.8125 6.84946 5.8125 6.75V5.0625C5.8125 4.21712 6.14832 3.40637 6.7461 2.8086C7.34387 2.21082 8.15462 1.875 9 1.875C9.84538 1.875 10.6561 2.21082 11.2539 2.8086C11.8517 3.40637 12.1875 4.21712 12.1875 5.0625V6.75Z"
      fill="#CCD6E0"
    />
  </svg>
);

export default styled(LockIcon)``;
